import './Icon_Search.css';

function Icon_Search() {
  return (
    
      <div className='search-icon-container'>
          <svg viewBox="0 0 24 24" className="responsive-svg">
              <path d="m21 21-4.34-4.34" />
              <circle cx="11" cy="11" r="6" />
          </svg>
      </div>
            
  );
}

export default Icon_Search;
